import { Controller } from "@hotwired/stimulus"

// SS-08: any touch, click or key goes back to where the kiosk was; the
// fallback clock ticks while there are no slides.
export default class extends Controller {
  static targets = ["clock"]
  static values = { returnTo: String }

  connect() {
    this.wake = this.wake.bind(this)
    // Ignore the tap that may still be in flight from the page we came from.
    this.armTimer = setTimeout(() => {
      ["pointerdown", "keydown"].forEach((type) => document.addEventListener(type, this.wake, { once: true }))
    }, 300)
    if (this.hasClockTarget) this.clockTimer = setInterval(() => this.tick(), 15000)
  }

  disconnect() {
    clearTimeout(this.armTimer)
    clearInterval(this.clockTimer)
    ;["pointerdown", "keydown"].forEach((type) => document.removeEventListener(type, this.wake))
  }

  wake() {
    window.Turbo.visit(this.returnToValue)
  }

  tick() {
    this.clockTarget.textContent = new Intl.DateTimeFormat("id-ID", { hour: "2-digit", minute: "2-digit" }).format(new Date())
  }
}
